import { useMemo } from 'react';

import { useRetailer } from '@lib/core/retailers/hooks/useRetailer';
import { createTasteJourneyData } from '@lib/core/service/utils';
import { useProductRate } from '@lib/core/users/hooks';
import { useTastePathProducts } from '@lib/tools/tastePathProducts/hooks/useTastePathProducts';

export const useTastePathJourneyData = () => {
  const { productRateData } = useProductRate();
  const { retailerMaxLengthTastePathPerCategory } = useRetailer();

  const { tastePathData, currentStyleCategoryId } = useTastePathProducts();

  const tastePathJourneyData = useMemo(
    () =>
      tastePathData
        ? createTasteJourneyData({
            currentStyleCategoryId,
            productRateData,
            retailerMaxLengthTastePathPerCategory,
            tastePathData,
          }).filter(Boolean)
        : [],
    [tastePathData, productRateData, currentStyleCategoryId],
  );

  return { tastePathJourneyData };
};
